/* eslint-disable react/display-name */
import React, { lazy, Suspense } from 'react';

import { Spinner } from '@gbm/queen-ui-guidelines';

import Backdrop from 'components/Backdrop';

const renderBackdrop = () => (
  <Backdrop variant="transparent">
    <Spinner size="sm" color="info" />
  </Backdrop>
);

const loadable = (
  importFunc,
  { fallback = null } = {
    fallback: renderBackdrop(),
  }
) => {
  const LazyComponent = lazy(importFunc);

  return props => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default loadable;
